import { Component, EventEmitter, Input, Output, ViewChild, ElementRef, HostListener, OnInit } from '@angular/core';
import { ANGULAR_MODULES } from '../Shared/shared-imports';
import Swal from 'sweetalert2';
import { firstValueFrom, Subject, Subscription, takeUntil } from 'rxjs';
import { UserService } from '../services/User.service';
import { Router } from '@angular/router';
import { GeneralService } from '../services/general.service';
import { DatePipe } from '@angular/common';
import { MarketInfoService } from '../services/marketInfo.service';
import { OperationRentalService } from '../services/Rentals.service';
import { SharedHTMLSettingsDataService } from '../Shared/sharedHTMLSettingsData.service';
import { IUserPermissionsModel } from '../Shared/model/AdminUserModel';
@Component({
  selector: 'app-top-bar',
  standalone: true,
  imports: [ANGULAR_MODULES],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.scss'
})
export class TopBarComponent implements OnInit {
  @Input() hideBtnToggler: boolean = false;
  public loaderIcon: Promise<boolean>;
  switchMarketOption: boolean;
  public marketList;
  displaySwitchStore = false;
  userName = '';
  dropdownOpen = false;
  marketDate;
  lastAccessed;
  marketName = "";
  private destroy$ = new Subject<void>();
  @ViewChild('dropdownButton') dropdownButton!: ElementRef;
  @ViewChild('dropdownMenu') dropdownMenu!: ElementRef;

  constructor(private router: Router,
    private userService: UserService,
    private datePipe: DatePipe,
    private generalService: GeneralService,
    private rentalService: OperationRentalService,
    private marketInfoService: MarketInfoService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,) {
    this.userName = this.userService.getLoggedInUserName();
  }

  @Output() toggleSidebar = new EventEmitter<void>();
  isMenuOpen: boolean = false;
  private subscriptions: Subscription[] = [];

  toggleDropdown(event: MouseEvent) {
    event.stopPropagation(); // prevent immediate close
    this.dropdownOpen = !this.dropdownOpen;
  }

  ngOnInit(): void {
    this.getDefaultMarketId();
    this.getMarketName();
    this.getMarketList();
    this.getMarketCurrentTime();
    this.userService.loggedInUserName$.pipe(takeUntil(this.destroy$)).subscribe(name => {
      this.userName = name;
    });
  }

  onclickSwitchMarket() {
    this.sharedHTMLSettings.openModalById('switchmarket');
    this.removeNotify_pop();
  }

  showPopupMessage(cls) {
    (document.querySelector('.topHearder') as HTMLElement).classList.toggle(cls);
    (document.querySelector('.containerForRemoveNotify') as HTMLElement).classList.toggle('Open');
    (document.querySelector('.topHearder') as HTMLElement).classList.remove('profile_toggle');
  }

  removeNotify_pop() {
    if ((document.querySelector('.topHearder') as HTMLElement).classList.contains('profile_toggle')) {
      this.showPopupMessage('profile_toggle');
      (document.querySelector('.containerForRemoveNotify') as HTMLElement).classList.remove('Open');
    }
  }

  @HostListener('document:click', ['$event'])
  closeDropdownOnOutsideClick(event: MouseEvent) {
    if (
      this.dropdownOpen &&
      this.dropdownButton &&
      this.dropdownMenu &&
      !this.dropdownButton.nativeElement.contains(event.target) &&
      !this.dropdownMenu.nativeElement.contains(event.target)
    ) {
      this.dropdownOpen = false;
    }
  }

  getDefaultMarketId() {
    this.subscriptions.push(this.rentalService.getDefaultMarketId().subscribe((res: any) => {
      if (res) {
        this.lastAccessed = res;
      }
    }));
  }

  updateChangedMarket() {
    this.subscriptions.push(this.userService.updateSwitchedMarketId(this.lastAccessed).subscribe((response) => {
      if (response) {
        this.reloadCurrentRoute();
      }
    }));
    this.sharedHTMLSettings.closeModalById('switchmarket');
  }

  async reloadCurrentRoute(): Promise<void> {
    const currentUrl = this.router.url;
    if (currentUrl.includes('/dashboard')) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        // navigate back to the original route
        this.router.navigate([currentUrl]);
      });
    } else {
      this.router.navigate(['/dashboard']);
    }
    await this.fetchUserPermissions();
  }

  async fetchUserPermissions() {
    try {
      const userPermission: IUserPermissionsModel = await firstValueFrom(this.generalService.GetUserPermission());
      this.generalService.UserPermissions = userPermission;
      this.generalService.userGroupPermissions.emit(userPermission);
    } catch (error) {
      console.error('Error fetching user the permissions', error);
    }
  }

  cancelSwitchMarket() {
    this.sharedHTMLSettings.closeModalById('switchmarket');
    this.getMarketList();
  }

  getMarketName() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.marketInfoService.getMarketName().subscribe((res: any) => {
      if (res) {
        this.marketName = res;
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getMarketList() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.marketInfoService.getMarketList().subscribe((res: any) => {
      this.marketList = [];
      if (res) {
        if (res.length > 0) {
          res.map((el, i) => {
            const ob = {
              MarketId: el.MarketId,
              MarketName: el.MarketName
            }
            this.marketList.push(JSON.parse(JSON.stringify(ob)));
          });
        }

        if (res.length > 1)
          this.displaySwitchStore = true;
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  getMarketCurrentTime(): void {
    this.generalService.GetMarketCurrentTime()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.marketDate = this.formatDate(res);
        },
        error: (err) => {
        }
      });
  }

  formatDate(dateValue: string | Date): string {
    return this.datePipe.transform(dateValue, 'd MMMM y'); // Example: 20 October 2025
  }

  logout() {
    this.dropdownOpen = false;
    Swal.fire({
      title: $localize`Are you sure ?`,
      text: $localize`Log out!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,

    }).then((result) => {
      if (result.value) {

        this.subscriptions.push(this.userService.clearToken().subscribe((res: any) => {
          this.router.navigate(['/login']);
        }));
      } else {
        return;
      }

    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onToggle(): void {
    this.toggleSidebar.emit();
    this.isMenuOpen = !this.isMenuOpen;
  }
}
